var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaintBrush(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7078 22.3964C12.1136 20.9323 10.6773 19.8999 9 19.8999C6.79086 19.8999 5 21.6908 5 23.8999C5 25.5568 3.65682 26.8999 1.99997 26.8999C1.93238 26.8999 1.86531 26.8977 1.79883 26.8933C2.83531 28.6903 4.77638 29.8999 6.99997 29.8999C10.3043 29.8999 12.9847 27.2288 12.9999 23.9281C13 23.9187 13 23.9093 13 23.8999C13 23.3681 12.8962 22.8606 12.7078 22.3964ZM12.7078 22.3964C14.3002 21.8537 15.8149 21.1272 17.2233 20.2369M10.5 20.2024C11.0431 18.6062 11.7708 17.088 12.663 15.6766M17.2233 20.2369C19.7306 18.652 21.9012 16.5482 23.5742 14.0386L28.7422 6.28665C28.9103 6.03447 29 5.73817 29 5.43509C29 4.58723 28.3127 3.8999 27.4648 3.8999C27.1617 3.8999 26.8654 3.98962 26.6132 4.15774L18.8613 9.32573C16.3517 10.9987 14.2479 13.1693 12.663 15.6766M17.2233 20.2369C16.3195 18.2109 14.689 16.5804 12.663 15.6766",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaintBrush);
export default __webpack_public_path__ + "static/media/paint-brush.63f4c4f0b7503b2cc0a23bfadac05a2d.svg";
export { ForwardRef as ReactComponent };